import React from 'react';
import ScrollContainer from "react-indiana-drag-scroll";

import './Mobile.css';

import Home from "../HomePage/Index";
import Cookies from "universal-cookie";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from "../../Actions/Index";
var cookie = new Cookies();

const list = [

  { name: "Khaadi", value: "1" },
  { name: "Limelight", value: "2" },
  { name: "Sapphire", value: "3" },
  { name: "Gulahmed", value: "4" },
  { name: "J. | JunaidJamshed", value: "5" },
  { name: "Ittehad Textiles", value: "6" },
  { name: "Waniya", value: "7" },
  { name: "Shoes", value: "10" },
  { name: "Jewellery", value: "11" },
  { name: "Dress", value: "12" },
  { name: "Bed Sheet", value: "13" },
  { name: "2PC", value: "14" },
  { name: "3PC", value: "15" },
  { name: "Stitched", value: "16" },
  { name: "Unstitched", value: "17" }
];
const list2 = [
  { color: '#F44336' },
  { color: '#2196F3' },
  { color: '#E91E63' },
  { color: 'white' },
  { color: 'grey' },
  { color: 'black' }


];
class Nav extends React.Component {
  state = {
    shown: false,
    activateFilter: null,
    activateColor: null,
    activateCat: [],
    productCatList: [],
    loadingBarProgress: 0,
    loaded: true,
    onload: true,
    showItems: 20,
    success: false,
    error: false,
    hasMore: true,
    isLoading: false,


  };
  ToggleCat = (e, ele) => {

    if (!this.state.activateCat.includes(ele)) {
      this.setState({
        activateCat: [...this.state.activateCat, ele]
      });
    }
    if (this.state.activateCat.includes(ele)) {
      let remove = this.state.activateCat.indexOf(ele);
      this.setState({
        activateCat: this.state.activateCat.filter((_, i) => i !== remove)
      });

    }
    console.log("categories=" + this.state.activateCat);
  }
  ToggleColor = (ele) => {
    if (this.state.activateColor !== ele) {
      this.setState({ activateColor: ele });
      console.log("color me " + this.state.activateColor);
    }
    if (this.state.activateColor === ele) {
      this.setState({ activateColor: null });
      console.log("color" + this.state.activateColor)
    }
  }
  ToggleFilter = (e, ele) => {
    if (this.state.activateFilter !== ele)
      this.setState({ activateFilter: ele });
    if (this.state.activateFilter === ele)
      this.setState({ activateFilter: null });
  }

  render() {


    let bor;
    return (
      <div style={{ marginTop: "90px" }}>
        <div className="Head">

          <div className="Filters">
            <ScrollContainer className="contents">

              <div onClick={(e) => this.ToggleFilter(e, 0)} className={`contentLink ${this.state.activateFilter === 0 ? "textBlue" : "textSimple"}`}>
                <div className="inner" >
                  Stitched
                </div>

              </div>

              <div onClick={(e) => this.ToggleFilter(e, 1)} className={`contentLink ${this.state.activateFilter === 1 ? "textBlue" : "textSimple"} `}>
                <div className="inner" >
                  Untstitched
                </div>

              </div>


              <div className={`contentLink textSimple`} onClick={(e) => {
                this.setState({ shown: !this.state.shown });
              }}>
                <div className="inner" >
                  Colour
                </div>
                <span className={this.state.shown ? 'Drop' : 'Dropped'} >  </span>



              </div>

              <div onClick={(e) => this.ToggleFilter(e, 3)} className={`contentLink ${this.state.activateFilter === 3 ? "textBlue" : "textSimple"}`}>
                <div className="inner" >
                  Men
                </div>

              </div>

              <div onClick={(e) => this.ToggleFilter(e, 4)} className={`contentLink ${this.state.activateFilter === 4 ? "textBlue" : "textSimple"}`}>
                <div className="inner" >
                  Women
                </div>

              </div>



              <div onClick={(e) => this.ToggleFilter(e, 5)} className={`contentLink ${this.state.activateFilter === 5 ? "textBlue" : "textSimple"}`}>
                <div className="inner" >
                  kids
                </div>

              </div>

            </ScrollContainer>
            {this.state.shown ? <div className="colorGrid">
              {list2.map(el => {
                const { color } = el;

                if (this.state.activateColor === color)
                  bor = "borderYellow";
                else
                  bor = "borderSimple";
                return <div onClick={() => this.ToggleColor(color)} className={`colours ${bor}`} style={{ backgroundColor: color }} key={color}> </div>;
              })}
            </div> : null
            }
          </div>
          <div className="categories">
            <ScrollContainer className="pn-ProductNav">
              <div className="pn-ProductNav_Contents ">

                {list.map(el => {
                  const { name } = el;

                  if (this.state.activateCat.includes(name))
                    bor = "borderBlue";
                  else
                    bor = "border";
                  return (<div className={`pn-ProductNav_Link ${bor}`} key={name} onClick={(e) => this.ToggleCat(e, name)}>

                    <div className="inner" key={el}>
                      {name}
                    </div>
                  </div>);
                })}
              </div>
            </ScrollContainer>
          </div>
        </div>

        <Home
          showItems={this.state.showItems}
          productCatList={this.state.productCatList}

        />
      </div>
    );
  }

}
const mapStateToProps = state => ({
  productsList: state.productsList
});

const mapDispatchToProps = dispatch => {
  return {
    getUserOrders: cat => dispatch(actionCreators.getUserOrders(cat))
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Nav)
);
